package com.rainbowclubs.rainbow.data.requests

import kotlinx.serialization.Serializable

@Serializable
data class AddEventCommentRequest(
    val commentText: String,
)
